import React from 'react';

import TextAvatar from '@components/common/TextAvatar';

import styles from './NetworkOperatorCell.module.scss';

interface INetworkOperatorCell {
	avatarId: string;
	name: string;
}

const NetworkOperatorCell = ({
	avatarId,
	name,
}: INetworkOperatorCell) => {
	return (
		<div className={styles.networkOperatorContainer}>
			<div className={styles.logo}>
				<TextAvatar
					avatarId={avatarId}
					fontSize='8px'
					fullName={name}
					isProfileLogo
					size='25px'
				/>
			</div>
			<div className={styles.name}>
				{name}
			</div>
		</div>
	);
};

export default NetworkOperatorCell;
